import { Shimmer } from '@wartek-id/shimmer'

import type { FC } from 'react'

type Props = {}

export const DetailLoading: FC<Props> = ({}) => {
  return (
    <div className="flex  gap-3 rounded px-3 py-4 max-w-4xl">
      <Shimmer rounded width={24} height={24} />
      <div className="space-y-4">
        <div className="space-y-2">
          <Shimmer width={500} height={24} />
          <Shimmer width={700} height={20} />
        </div>
        <div className="space-y-1">
          <Shimmer width={300} height={20} />
          <Shimmer width={250} height={20} />
          <Shimmer width={350} height={20} />
        </div>
        <Shimmer width={155} height={38} />
      </div>
    </div>
  )
}
